import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import config from '../../config'

const publicUrl = config.PUBLIC_URL

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    margin: '0px',
  },
  paperTitle: {
    color: theme.palette.text.primary,
  },
  item: {
    position: 'relative',
    textAlign: 'center',
    padding: '24px 6px',
    minWidth: '300px',
  },
  icons: {
    width: '48px',
    margin: '8px 0',
  },
}))

export const BaseWidget = ({ props, children }) => {
  const classes = useStyles()
  const iconsMapping = {
    4: 'default', // petites interventions
    5: 'invoice', // facturation
    6: 'emergency', // interventions urgentes
    7: 'calendar', // état daté
    8: 'calendar', // pré état daté
    9: 'law', // juridique
    13: 'competition', // mise en concurrence
    14: 'home', // visit
    15: 'megaphone', // action copro manager
  }
  if (props.listmode === true) return null

  return (
    <Grid className={classes.item}>
      <Paper
        className={classes.paper}
        style={{ minHeight: props.minHeight || 'inherit' }}
      >
        {props.icon && (
          <img
            className={classes.icons}
            src={`${publicUrl + `/img/icons/${props.icon}.svg`}`}
          />
        )}
        {/* Keep compatibility backwards */}
        {!props.icon && (
          <img
            className={classes.icons}
            src={`${
              publicUrl +
              `/img/icons/${iconsMapping[props.id] || 'default'}.svg`
            }`}
          />
        )}
        <Typography className={classes.paperTitle} gutterBottom>
          {props.name}
        </Typography>
        {children}
      </Paper>
    </Grid>
  )
}
